import React from "react";
import styles from "./CollectionTrustMarkerBadge.module.scss";
import { getTrustMarkerStyleClass } from "@configs/trustMarkerStyleConfig";

export interface CollectionTrustMarkerBadgeProps {
  label: string;
  className?: string;
}

const CollectionTrustMarkerBadge: React.FC<CollectionTrustMarkerBadgeProps> = ({
  label,
  className = "",
}) => {
  const styleClass = getTrustMarkerStyleClass(label);

  return (
    <div
      className={`${styles.collectionTrustMarkerBadge} ${styles[styleClass]} ${className}`}
    >
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default CollectionTrustMarkerBadge;

